import React from 'react';
import styled from 'styled-components';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
// import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { getDateTimeFormat } from '@nile/components';
import withErrorBoundary from '@nile/components/src/HOC/withErrorBoundary';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';

const CalendarStyles = styled.div`
  .Event-Calender {
    overflow: scroll;
    position: relative;
    background: white;
    .rbc-toolbar,
    .rbc-time-header {
      display: none;
    }

    .rbc-timeslot-group {
      min-height: 150px;
      background: white;
      border-top: 1px solid #f7f7f7;
      border-bottom: 1px solid #f7f7f7;
      border-left: none;
      border-right: none;
    }

    .rbc-time-slot,
    .rbc-time-content {
      border: none;
    }

    .rbc-label {
      color: rgba(75, 79, 82, 0.71);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
    }
    .rbc-slot-selection {
      border-radius: 5px;
      border: 1px dashed #5f8bff !important;
      background: rgba(242, 246, 255, 0.9);
      color: #323232;
      font-weight: 600;
      padding-left: 15px;
    }

    .rbc-time-content > * + * > * {
      border-left: none;
    }
  }
`;
const EventCalendar = (props) => {
  const is24hours = getDateTimeFormat()?.timeType === '24Hours';

  if (is24hours) {
    moment.locale('en-GB');
  } else {
    moment.locale('ko', {
      week: {
        dow: 1,
        doy: 1
      }
    });
  }

  const localizer = momentLocalizer(moment); // End calendar settings

  const CalendarComponent = props?.enableDragAndDrop
    ? withDragAndDrop(Calendar)
    : Calendar;

  const resizeEvent = (data) => {
    if (props?.onEventResize) {
      props?.onEventResize(data);
    }
  };

  const eventDrop = (data) => {
    if (props?.onEventDrop) {
      props?.onEventDrop(data);
    }
  };

  const componentsFromProps = props?.components || {};

  const TimeSlotWrapper = (props) => {
    const hours = new Date(props.value).getHours();
    return <div id={`time-slot-${hours}`}>{props.children}</div>;
  };

  const components = {
    timeSlotWrapper: TimeSlotWrapper,
    ...componentsFromProps
  };

  return (
    <CalendarStyles>
      <div className="Event-Calender">
        <CalendarComponent
          defaultDate={props?.defaultDate}
          date={props?.defaultDate}
          defaultView={props?.defaultView || Views.DAY}
          events={props?.events || []}
          backgroundEvents={props?.backgroundEvents || []}
          localizer={localizer}
          onEventResize={resizeEvent}
          components={components}
          onEventDrop={eventDrop}
          step={props?.step}
          timeslots={props?.timeslots}
          onSelecting={props?.onSelecting}
          selectable={props?.selectable || props?.onSelecting ? true : false}
        />
      </div>
    </CalendarStyles>
  );
};

export default withErrorBoundary(EventCalendar);
